import { ReportFiltersValues } from '@/features/Analytics/stores/useAnalyticsFiltersStore/types'
import { parseTimelineFilter } from '@/components/common/Filter/TimelineFilter/utils'
import { GetPayablesSummaryRequestParams } from '@/hooks'
import { toArrayQueryParams } from '@/utils/toArrayQueryParams'

export const mapBillingFiltersGetParams = ({
    filters,
}: {
    filters: ReportFiltersValues
}) => {
    const timelineValue = parseTimelineFilter(filters.timeline)

    const params: GetPayablesSummaryRequestParams = {
        'nodeIds[]': toArrayQueryParams(filters.node),
        'commodityTypeIds[]': toArrayQueryParams(filters.commodity),
        startDate: timelineValue.startDate,
        endDate: timelineValue.endDate,
        'facilityIds[]': toArrayQueryParams(filters.facility),
        'providerIds[]': toArrayQueryParams(filters.provider ?? []),
        'contractIds[]': toArrayQueryParams(filters.contract),
        'panIds[]': toArrayQueryParams(filters.account ?? []),
        'tagIds[]': toArrayQueryParams(filters.tag),
        'usnAccountIds[]': toArrayQueryParams(filters.usn ?? []),
        'invoiceNumbers[]': toArrayQueryParams(filters.invoiceNo ?? []),
    }

    return params
}
